import { RootState } from "@/app/stores"

export const selectLoyaltyAnalyticsFilters = (state: RootState) => state.loyaltyAnalytics
export const selectLoyaltyAnalyticsPeriod = (state: RootState) => state.loyaltyAnalytics.period
export const selectLoyaltyAnalyticsStoreIds = (state: RootState) => state.loyaltyAnalytics.storeIds
export const selectLoyaltyAnalyticsIncludeUnassignedStore = (state: RootState) =>
    state.loyaltyAnalytics.includeUnassignedStore
export const selectLoyaltyAnalyticsLevels = (state: RootState) => state.loyaltyAnalytics.levels
export const selectLoyaltyAnalyticsIncludeUnknownLevel = (state: RootState) =>
    state.loyaltyAnalytics.includeUnknownLevel
export const selectLoyaltyAnalyticsIncludeReturns = (state: RootState) => state.loyaltyAnalytics.includeReturns
export const selectLoyaltyAnalyticsPage = (state: RootState) => state.loyaltyAnalytics.page

export const selectLoyaltyStatisticsAppliedFiltersCount = (state: RootState): number => {
    return Number(state.loyaltyAnalytics.levels.length > 0)
        + Number(state.loyaltyAnalytics.includeUnknownLevel)
}

export const selectLoyaltyReportsAppliedFiltersCount = (state: RootState): number => {
    const filters = state.loyaltyAnalytics

    return Number(filters.storeIds.length > 0)
        + Number(filters.includeUnassignedStore)
        + Number(filters.levels.length > 0)
        + Number(filters.includeUnknownLevel)
}

export const selectLoyaltyAccrualsAppliedFiltersCount = (state: RootState): number => {
    const filters = state.loyaltyAnalytics

    return Number(filters.storeIds.length > 0)
        + Number(filters.includeUnassignedStore)
        + Number(filters.levels.length > 0)
        + Number(filters.includeUnknownLevel)
        + Number(filters.includeReturns)
}
